import { Button, Row } from "antd";
import { ScheduleEmail, ScheduleEmailOptions } from "../../../components/ScheduleEmail";
import { useCallback, useMemo } from "react";
import dayjs from "dayjs";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useSend } from "../hooks/useSend";
import ROUTES from "../../../configs/routesConfig";
import { useSelector } from "react-redux";

type HeaderProps = {
  form: any;
  request: any;
  count: number;
  isLoading: boolean;
};

export const Header = ({ form, request, count, isLoading }: HeaderProps) => {
  const navigate: NavigateFunction = useNavigate();

  const onCancelButtonClicked = useCallback(() => navigate(-1), [navigate]);

  const { send, isSending } = useSend(form, count, () => navigate(`${ROUTES.EMAILS}`));

  const metaData = useSelector((state: any) => state.metaData);

  const scheduleInitialData = useMemo(() => {
    const scheduledDate = dayjs().add(1, "day").hour(8);

    return {
      frequencyType: 1,
      scheduledDate: scheduledDate,
      endConditionType: 3,
      endDate: scheduledDate.add(5, "year"),
      maxOccurrences: 5
    };
  }, []);

  const scheduleOptions: ScheduleEmailOptions = useMemo(() => {
    const statusFilter = request?.criteria?.statusesFilter;
    const options: ScheduleEmailOptions = {
      enabledUntilAccountClosed: true,
      enabledOnOccurrences: true,
      enabledOnEndDate: true
    };

    if (
      statusFilter &&
      statusFilter.some(
        (status: number) => status === 1 || status === 2 || status === 3 || status === 4 || status === 5
      )
    ) {
      options.enabledUntilAccountClosed = false;
    }

    return options;
  }, [request]);

  return (
    <Row className="d-flex w-100 justify-space-between">
      <Row className="my-6 ml-8">
        <h3 className="h h3">New Emails</h3>
      </Row>
      <Row className="my-6 mr-8">
        <Button
          shape="round"
          type="primary"
          onClick={() => send()}
          loading={isSending}
          disabled={isLoading || count === 0}
        >
          Send
        </Button>
        {metaData.featureFlags.ScheduledEmails && (
          <ScheduleEmail
            form={form}
            initialData={scheduleInitialData}
            onSchedule={send}
            disabled={isLoading || count === 0}
            isLoading={isSending}
            options={scheduleOptions}
          />
        )}
        <Button shape="round" className="ml-2" onClick={onCancelButtonClicked} disabled={isSending}>
          Cancel
        </Button>
      </Row>
    </Row>
  );
};
